//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/ToolDesigner.js";
import "../no/Builder.js";
import "../no/SelectTaggedObject.js";
import "../no/SelectObject.js";
let d=[[[0,"AnimateGunRotation",1,0],[0,"FlipGunDirection",1,0],[1,"GunSelection",0,"SelectTaggedObject",0],[0,"RotateAngleDouble",1,0],[0,"ScaleStepSizeDouble",1,0],[0,"StepSizeDouble",1,0],[1,"WeldSelection",0,"SelectTaggedObject",0]],[[["gunSelection"],"SetGunSelection",{},1,0],[["weldSelection"],"SetWeldSelection",{},1,0],[[],"CalcClearanceButton",{},0,0],[[],"NextButton",{},0,0],[[],"PrevButton",{},0,0],[[],"SetApproachButton",{},0,0],[[],"UpdateGunPosition",{},0,0],[["degree"],"FastGunRotation",{},1,0],[["pieChartBuilder"],"SetReusePieChartBuilder",{},1,0],[[],"InitDraggedObject",{},0,0],[[],"FlipGun",{},0,0]],[]];
SPLM.ToolDesigner.SetGunApproachBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.ToolDesigner.SetGunApproachBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;